import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import { ProfileService, SPSmtpService } from '../profile.service';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { MatDialog } from '@angular/material';
import { AlertComponent } from '../../shared/alert/alert.component';

@Component({
  selector: 'app-campaignregistry',
  templateUrl: './campaignregistry.component.html',
  styleUrls: ['./campaignregistry.component.css']
})
export class CampaignregistryComponent implements OnInit {
  campaign: FormGroup;
  formdata: any;
  public smstemp$ = new BehaviorSubject<any>({});
  public templateList = this.smstemp$.asObservable();
  packageid = sessionStorage.getItem("id_package");
  public allcamp: any = JSON.parse(sessionStorage.getItem("allcampaign"));
  campain: any;
  templateLenght: any;
  secStp: boolean;
  template:any=[];
  Allcampaign:any=[];
  smstemp_id: any = [];
  brand_type: any;
  brandId: any;
  cspId: any;
  myEntity:any;
  Disable:boolean=false
  isDisable:boolean=false
  alertMsg:boolean=false
  ScaMpID:any=[]
  FcaMpID:any=[]
  idcamp:any;
  agentCode:any
  matDialogReference: any;
  Mcontent: any=[];
  constructor(public dialog: MatDialog,frmbuilder: FormBuilder,public data: ProfileService,public smtdata:SPSmtpService) { 
    this.campain = this.allcamp[0].id;
    console.log( this.allcamp);
    this.campaign = frmbuilder.group({
      dialers: (''),
    });
  }

  ngOnInit() {
    //Getting data Obervable
    this.smtdata.themecolor1.subscribe(res=>{
      console.log(res)
      this.myEntity=res.entity_type;
      this.idcamp=res.campaign_id;
      console.log("this.myEntity",this.myEntity);
    })

    this.template=this.templateList
    this.Allcampaign=this.allcamp
    this.data.getSmsTemplate(this.allcamp[0].id).subscribe(res => {
      console.log(res)
      this.templateLenght = res.length
      this.secStp = true
      this.smstemp$.next(res)
      this.templateList.subscribe((res:any) =>{
        res.forEach(element => {
          element.disable = false
        });
        console.log(res);
    })
    }, err => {
      this.templateLenght = 0
      this.secStp = true
      this.smstemp$.next([])
    })
    this.data.getBrandIdService("gettcpacamp").subscribe(res=>{
      console.log(res);
      this.brandId=res[0].brand_id;
      this.cspId=res[0].cspId;
    },err=>{
      this.brandId='';
    })

    this.data.getService("brandtype", { id: this.packageid }).subscribe((res: any) => {
      if (res[0].brand_type != null || res[0].brand_type != undefined || res[0].brand_type != '') {
        this.brand_type = res[0].brand_type;
        sessionStorage.setItem("brand_type", res[0].brand_type)
      }
    })

    this.data.getBrandIdService("gettcpacamp").subscribe(res=>{
      console.log(res);
      this.brandId=res[0].brand_id;
      this.cspId=res[0].cspId;
      this.agentCode=res[0].agent_code;
    },err=>{
      this.brandId='';
    })
  }
  changeDialer(event:any){
   // this.smstemp_id.length = 0;
    console.log(event.value);
    this.data.getSmsTemplate(event.value).subscribe(res => {
      console.log(res)
      this.template=res
      this.templateLenght = res.length
      this.secStp = true
      this.smstemp$.next(res)
    }, err => {
      this.templateLenght = 0
      this.secStp = true
      this.smstemp$.next([])
    })
  }
  oncheckbox(event:any, sms_id:any){
    console.log(event);
    if(event.checked==true){
      this.smstemp_id.push(sms_id)
      console.log(this.smstemp_id);
    }else{
      this.smstemp_id.splice(this.smstemp_id.indexOf(sms_id),1)
      console.log(this.smstemp_id);
    }
  }
  registerCampaign(){
    this.campaign.value
    if(this.smstemp_id.length>=3 && this.smstemp_id.length<=5){
      this.isDisable=true;
      this.data.regiscamp(JSON.stringify({formdata:this.campaign.value,smstemp_id:this.smstemp_id, brandid: this.brandId,cspId:this.cspId})).subscribe(res=>{
        if(res!=''){
          console.log(res);
          this.Mcontent
          this.alertMsg=true
            for (var rsvl of res) {
                    this.ScaMpID.push(rsvl.id);
                    this.Mcontent.push(rsvl.content);
                }
                this.data.campRegistration(JSON.stringify({ brandid: this.brandId,cspId:this.cspId,smstemp: this.Mcontent,templteID:this.smstemp_id,agentCOde:this.agentCode,entity:this.myEntity,campaignID:this.idcamp})).subscribe(res=>{
                  this.isDisable=false;
                  alert(res.message)
                })
        }
      },err=>{
        alert("Registraion Failed !!")
        console.log(err);
        
      });
    }else{
      const dialogRef = this.dialog.open(AlertComponent, {
        disableClose: true,
        width: '600px',
        data: {
          type: 102,
        }
      });
    }
  }
}
